import { Container } from "react-bootstrap";
import "./GenerateQuestion.css";

const GenerateQuestion = (props) => {
  return (
      <Container className="custom-margin-left-mobile">
        <h2 className="header">{props.header}</h2>
        <h3 className="subheader">{props.subheader}</h3>
      </Container>
  );
};

export default GenerateQuestion;
